export const te = {
  // Navigation (Telugu)
  explore: 'అన్వేషించు',
  search: 'వెతుకు',
  create: 'పోస్ట్ సృష్టించు',
  messages: 'సందేశాలు',
  notifications: 'నోటిఫికేషన్లు',
  settings: 'సెట్టింగులు',
  profile: 'ప్రొఫైల్',
  logout: 'లాగ్ అవుట్',
  home: 'హోమ్',
  
  // Authentication
  signin: 'సైన్ ఇన్',
  signup: 'సైన్ అప్',
  login: 'లాగిన్',
  register: 'రిజిస్టర్',
  email: 'ఇమెయిల్',
  password: 'పాస్‌వర్డ్',
  confirmPassword: 'పాస్‌వర్డ్ నిర్ధారించు',
  firstName: 'మొదటి పేరు',
  lastName: 'చివరి పేరు',
  forgotPassword: 'పాస్‌వర్డ్ మర్చిపోయారా?',
  alreadyHaveAccount: 'ఇప్పటికే ఖాతా ఉందా? సైన్ ఇన్ చేయండి',
  dontHaveAccount: 'ఖాతా లేదా? సైన్ అప్ చేయండి',
  
  // Posts & Content
  recent: 'ఇటీవలి',
  trending: 'ట్రెండింగ్',
  popular: 'జనాదరణ పొందిన',
  like: 'ఇష్టం',
  likes: 'ఇష్టాలు',
  comment: 'వ్యాఖ్య',
  comments: 'వ్యాఖ్యలు',
  share: 'షేర్',
  delete: 'తొలగించు',
  edit: 'సవరించు',
  post: 'పోస్ట్',
  posts: 'పోస్ట్లు',
  title: 'శీర్షిక',
  content: 'కంటెంట్',
  tags: 'ట్యాగ్లు',
  noBlogsFound: 'బ్లాగులు కనుగొనబడలేదు। మరేదైనా వెతకడానికి ప్రయత్నించండి లేదా మొదటిది సృష్టించండి!',
  
  // AI Assistant
  quickActions: 'త్వరిత చర్యలు',
  writeCaption: 'క్యాప్షన్ రాయండి',
  suggestTopics: 'అంశాలను సూచించండి',
  improveContent: 'కంటెంట్‌ను మెరుగుపరచండి',
  creativeIdeas: 'సృజనాత్మక ఆలోచనలు',
  clearChat: 'చాట్ క్లియర్ చేయండి',
  aiWritingAssistant: 'AI రైటింగ్ అసిస్టెంట్',
  poweredByGroq: 'GROQ AI ద్వారా శక్తివంతం',
  aiGreeting: 'హలో! నేను మీ AI రైటింగ్ అసిస్టెంట్। నేను మీకు ఆకర్షణీయమైన కంటెంట్ సృష్టించడంలో, క్యాప్షన్లు రాయడంలో, పోస్ట్ అంశాలను సూచించడంలో మరియు మీ రచనను మెరుగుపరచడంలో సహాయం చేయగలను। ఈరోజు మీరు దేనిపై పని చేయాలనుకుంటున్నారు?',
  askMeToHelp: 'కంటెంట్, క్యాప్షన్లు, అంశాలు లేదా రచనతో సహాయం కోసం నన్ను అడగండి...',
  aiThinking: 'AI ఆలోచిస్తోంది...',
  
  // Chat & Messages
  chat: 'చాట్',
  noConversationsYet: 'ఇంకా సంభాషణలు లేవు',
  ideafluxChat: 'IdeaFlux చాట్',
  typeMessage: 'సందేశం టైప్ చేయండి...',
  sendMessage: 'సందేశం పంపండి',
  connectingToChat: 'చాట్‌కు కనెక్ట్ అవుతోంది...',
  
  // Notifications
  noNotificationsYet: 'ఇంకా నోటిఫికేషన్లు లేవు।',
  markAllRead: 'అన్నింటినీ చదివినట్లు గుర్తించు',
  clearAll: 'అన్నింటినీ క్లియర్ చేయి',
  
  // Settings
  accountSettings: 'ఖాతా సెట్టింగులు',
  displayName: 'ప్రదర్శన పేరు',
  emailAddress: 'ఇమెయిల్ చిరునామా',
  languagePreference: 'భాష ప్రాధాన్యత',
  privacySecurity: 'గోప్యత & భద్రత',
  notificationPreferences: 'నోటిఫికేషన్ ప్రాధాన్యతలు',
  allowDirectMessages: 'ప్రత్యక్ష సందేశాలను అనుమతించు',
  letOthersMessage: 'ఇతర వినియోగదారులు మీకు ప్రైవేట్ సందేశాలు పంపడానికి అనుమతించండి',
  likesOnPosts: 'పోస్ట్లపై ఇష్టాలు',
  commentsOnPosts: 'పోస్ట్లపై వ్యాఖ్యలు',
  newFollowers: 'కొత్త అనుచరులు',
  mentions: 'ప్రస్తావనలు',
  save: 'సేవ్ చేయి',
  deleteAccount: 'ఖాతాను తొలగించు',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'ఎవరైనా ఉన్నప్పుడు నోటిఫికేషన్ పొందండి',
  likesYourPosts: 'మీ పోస్ట్లను ఇష్టపడతారు',
  commentsOnYourPosts: 'మీ పోస్ట్లపై వ్యాఖ్యానిస్తారు',
  followsYou: 'మిమ్మల్ని అనుసరిస్తారు',
  mentionsYou: 'మిమ్మల్ని ప్రస్తావిస్తారు',
  chooseNotifications: 'మీరు ఏ నోటిఫికేషన్లు స్వీకరించాలనుకుంటున్నారో ఎంచుకోండి',
  controlWhoInteracts: 'మీతో ఎవరు పరస్పర చర్య చేయగలరో నియంత్రించండి',
  manageAccountInfo: 'మీ ఖాతా సమాచారం మరియు ప్రాధాన్యతలను నిర్వహించండి',
  emailCannotBeChanged: 'భద్రతా కారణాల వల్ల ఇమెయిల్ మార్చలేరు',
  
  // Common
  loading: 'లోడ్ అవుతోంది...',
  cancel: 'రద్దు చేయి',
  update: 'అప్‌డేట్ చేయి',
  submit: 'సమర్పించు',
  back: 'వెనుకకు',
  next: 'తదుపరి',
  previous: 'మునుపటి',
  online: 'ఆన్‌లైన్',
  offline: 'ఆఫ్‌లైన్',
  
  // Profile
  editProfile: 'ప్రొఫైల్ సవరించు',
  noBioYet: 'ఇంకా బయో లేదు।',
  followers: 'అనుచరులు',
  following: 'అనుసరిస్తున్న',
  recentActivity: 'ఇటీవలి కార్యకలాపం',
  noPostsYet: 'ఇంకా పోస్ట్లు లేవు',
  shareFirstPost: 'మీ మొదటి పోస్ట్ షేర్ చేయండి!',
  bio: 'బయో',
  dateOfBirth: 'పుట్టిన తేదీ',
  follow: 'అనుసరించు',
  unfollow: 'అనుసరించవద్దు',
  
  // Search
  discover: 'కనుగొను',
  findPeopleStories: 'మీకు ముఖ్యమైన వ్యక్తులు, కథలు మరియు ఆలోచనలను కనుగొనండి',
  searchByName: 'పేరు, శీర్షిక లేదా #ట్యాగ్ ద్వారా వెతకండి...',
  searchResults: 'శోధన ఫలితాలు',
  noResultsFound: 'ఫలితాలు కనుగొనబడలేదు',
  peopleFound: 'వ్యక్తులు దొరికారు',
  
  // Settings - Additional keys
  enterDisplayName: 'మీ ప్రదర్శన పేరును నమోదు చేయండి',
  saving: 'సేవ్ చేస్తోంది...',
  confirmDeleteAccount: 'మీరు మీ ఖాతాను తొలగించాలని నిశ్చయించుకున్నారా? దీన్ని రద్దు చేయలేరు।',
  accountDeletedSuccessfully: 'ఖాతా విజయవంతంగా తొలగించబడింది।',
  errorDeletingAccount: 'ఖాతాను తొలగించడంలో లోపం। దయచేసి మళ్లీ ప్రయత్నించండి।',
  settingsSavedSuccessfully: 'సెట్టింగులు విజయవంతంగా సేవ్ చేయబడ్డాయి!',
  failedToSaveSettings: 'సెట్టింగులను సేవ్ చేయడంలో విఫలమైంది। దయచేసి మళ్లీ ప్రయత్నించండి।',
  
  // Form component
  pleaseSignInToCreate: 'పోస్ట్ సృష్టించడానికి సైన్ ఇన్ చేయండి।',
  titleRequired: 'పోస్ట్ ప్రచురించడానికి శీర్షిక అవసరం।',
  contentRequired: 'పోస్ట్ ప్రచురించడానికి కథ కంటెంట్ అవసరం।',
  contentTooShort: 'కథ కంటెంట్ కనీసం 10 అక్షరాల పొడవు ఉండాలి।',
  postUpdatedSuccessfully: 'పోస్ట్ విజయవంతంగా అప్‌డేట్ చేయబడింది!',
  postPublishedSuccessfully: 'పోస్ట్ విజయవంతంగా ప్రచురించబడింది!',
  pleaseSignInToCreateBlogs: 'మీ స్వంత IdeaFlux బ్లాగులను సృష్టించడానికి సైన్ ఇన్ చేయండి।',
  enterEngagingTitle: 'ఆకర్షణీయమైన శీర్షికను నమోదు చేయండి...',
  story: 'కథ',
  writeYourMasterpiece: 'మీ మాస్టర్‌పీస్ రాయండి...',
  addTags: 'ట్యాగ్లను జోడించండి...',
  add: 'జోడించు',
  publishPost: 'పోస్ట్ ప్రచురించు',
  
  // Post component
  linkCopiedToClipboard: 'లింక్ క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది! షేర్ కౌంట్ అప్‌డేట్ చేయబడింది।',
  youAndOthers: 'మీరు మరియు {{count}} ఇతరులు',
  unknownUser: 'తెలియని వినియోగదారు',
  noImage: 'చిత్రం లేదు',
  deletePost: 'పోస్ట్ తొలగించు',
  confirmDeletePost: 'మీరు ఈ పోస్ట్‌ను తొలగించాలని నిశ్చయించుకున్నారా?',
};
